var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"max-height":"68","contain":"","max-width":"179","src":require("../../assets/hexalud_logo.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }